module.exports = __webpack_public_path__ + "images/花筑院子全景_08-2.jpg?v=bb93cb8c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_08-2.jpg
 ** module id = 82
 ** module chunks = 1 2
 **/